import { render, staticRenderFns } from "./ExtendedTab.vue?vue&type=template&id=686d9930"
import script from "./ExtendedTab.vue?vue&type=script&lang=ts"
export * from "./ExtendedTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686d9930')) {
      api.createRecord('686d9930', component.options)
    } else {
      api.reload('686d9930', component.options)
    }
    module.hot.accept("./ExtendedTab.vue?vue&type=template&id=686d9930", function () {
      api.rerender('686d9930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ExtendedTab.vue"
export default component.exports